// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LdRR","checkbox_active":"Checkbox_checkbox_active__3wLs8"};